/* sdx-cart-drawer — sağdan açılan sepet paneli (v3.8, 2026-10-27).
 * Açılır: ürün sepete eklenince (`cart:added`, sdx-cart.js) ve header'daki sepet ikonuna
 * tıklanınca. Sepet sayfasında açılmaz (sayfa zaten sepetin kendisi), ikon /cart'a gider.
 * İçerik sunucuda çizilir (sections/sdx-cart-drawer.liquid); burada yalnız
 * `?sections=sdx-cart-drawer` ile tazelenip `[data-sdx-cd-part]` parçaları değiştirilir.
 * Hediye ilerlemesi parça dışında, sdx-gwp.js doldurur. `.sdx-cd.is-open` sdx-gwp.js'in
 * sıra kapısıdır (panel açıkken hediye pop-up'ı açılmaz). */
(function () {
  'use strict';
  const root = document.getElementById('sdx-cd');
  if (!root || root.dataset.sdxCdInit) return;
  root.dataset.sdxCdInit = '1';

  const SECTION = 'sdx-cart-drawer';
  let lastFocus = null;
  let seq = 0;
  let timer = null;

  const REC_LIMIT = parseInt(root.dataset.recLimit, 10) || 3;
  let gwp = null; // son `sdx:gwp-state` (sdx-gwp.js): { next: {name, remaining, remainingText} | null, hasCampaign }

  const onCartPage = () => !!document.querySelector('[data-sdx-cart-page]');
  const tpl = (key, vars) => Object.keys(vars).reduce((s, k) => s.split('__' + k + '__').join(vars[k]), root.dataset[key] || '');
  const isOpen = () => root.classList.contains('is-open');

  async function refresh() {
    const my = ++seq;
    root.classList.add('is-loading');
    try {
      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const res = await fetch(base + '?sections=' + SECTION, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!res.ok) throw new Error('sections ' + res.status);
      const data = await res.json();
      if (my !== seq || !data[SECTION]) return;
      const doc = new DOMParser().parseFromString(data[SECTION], 'text/html');
      root.querySelectorAll('[data-sdx-cd-part]').forEach((el) => {
        const next = doc.querySelector('[data-sdx-cd-part="' + el.getAttribute('data-sdx-cd-part') + '"]');
        if (next) el.replaceWith(next);
      });
      applyGoal(); // yeni çizilen öneri listeleri hedefe göre yeniden sıralanır
    } catch (err) {
      console.error('[sdx-cart-drawer]', err);
    } finally {
      if (my === seq) root.classList.remove('is-loading');
    }
  }

  /**
   * Hediye hedefi (sepet ortalaması): sıradaki kademe kazanılmamışsa
   *  - ana buton "Alışverişe devam et" olur (kök `.is-goal`), "Ödemeye geç" ikincil
   *  - hediye çubuğunun altında teşvik satırı
   *  - öneriler: kalan tutarı TEK BAŞINA kapatanlar önce (en az aşan önde), sonra fiyatı
   *    kalana en yakın olanlar; ilk REC_LIMIT kart gösterilir, kapatanlara not eklenir.
   * Hedef yoksa (tüm hediyeler kazanıldı / kampanya kapalı) sunucu sırası ve ödeme önde.
   */
  function applyGoal() {
    const next = gwp && gwp.next && gwp.next.remaining > 0 ? gwp.next : null;
    root.classList.toggle('is-goal', !!next);

    let closers = 0;
    root.querySelectorAll('.sdx-cd__recs-list').forEach((list) => {
      const cards = Array.from(list.querySelectorAll('[data-sdx-cd-rec]'));
      if (!cards.length) return;
      if (!list.dataset.order) list.dataset.order = cards.map((c, i) => (c.dataset.idx = i)).join(',');
      const price = (c) => parseInt(c.dataset.price, 10) || 0;
      let sorted;
      if (next) {
        const r = next.remaining;
        sorted = cards.slice().sort((a, b) => {
          const ca = price(a) >= r, cb = price(b) >= r;
          if (ca !== cb) return ca ? -1 : 1;
          return ca ? price(a) - price(b) : price(b) - price(a);
        });
      } else {
        sorted = cards.slice().sort((a, b) => a.dataset.idx - b.dataset.idx);
      }
      // Not yalnız İLK kapatan kartta (en ucuz kapatan); diğerlerinde tekrar etmez,
      // genel çağrı zaten teşvik satırında.
      let shownClosers = 0;
      sorted.forEach((c, i) => {
        list.appendChild(c);
        c.hidden = i >= REC_LIMIT;
        const closes = !!next && price(c) >= next.remaining;
        const note = closes && !c.hidden && shownClosers === 0;
        const goal = c.querySelector('[data-sdx-cd-rec-goal]');
        if (goal) {
          goal.hidden = !note;
          goal.textContent = note ? tpl('tRecGoal', { GIFT: next.name }) : '';
        }
        if (closes && !c.hidden) shownClosers++;
      });
      closers = Math.max(closers, shownClosers);
    });

    const nudge = root.querySelector('[data-sdx-cd-nudge]');
    if (nudge) {
      const hasItems = !!root.querySelector('.sdx-cd__item');
      nudge.hidden = !(next && hasItems);
      nudge.textContent = next && hasItems
        ? (closers ? tpl('tNudgeRec', { GIFT: next.name }) : tpl('tNudgeAmount', { AMOUNT: next.remainingText, GIFT: next.name }))
        : '';
    }
  }

  document.addEventListener('sdx:gwp-state', (e) => {
    gwp = e.detail || null;
    applyGoal();
  });

  function open() {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sdx-cd-lock');
    const title = root.querySelector('#sdx-cd-title');
    if (title) title.focus({ preventScroll: true });
  }

  function close() {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sdx-cd-lock');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-sdx-cd-close]')) { close(); return; }
    const add = e.target.closest('[data-sdx-cd-rec-add]');
    if (add && !add.disabled && window.SdxCart) {
      add.disabled = true;
      add.classList.add('is-loading');
      window.SdxCart.add({ items: [{ id: parseInt(add.getAttribute('data-variant-id'), 10), quantity: 1 }] })
        .catch((err) => {
          console.error('[sdx-cart-drawer]', err);
          add.disabled = false;
          add.classList.remove('is-loading');
        });
    }
  });

  document.addEventListener('keydown', (e) => {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    // Odak panelin (ve öneri sütununun) içinde döner.
    const items = Array.from(root.querySelectorAll('a[href], button:not([disabled]), input, [tabindex="0"]'))
      .filter((el) => el.offsetParent !== null && el.getAttribute('tabindex') !== '-1');
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });

  // Header sepet ikonu: sayfaya gitmek yerine paneli aç (sepet sayfasında normal link).
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-sdx-cart-trigger]');
    if (!trigger || onCartPage() || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open();
    refresh();
  });

  document.addEventListener('cart:added', () => {
    if (onCartPage()) return;
    open();
    refresh();
  });

  // Adet/kaldır ve hediye eklenip çıkarılması art arda birkaç olay üretir → tek tazeleme.
  // Panel kapalıyken tazelenmez (sayfa yüklenişindeki cart:change gereksiz istek olurdu);
  // her açılışta zaten tazelenir.
  document.addEventListener('cart:change', () => {
    if (!isOpen()) return;
    clearTimeout(timer);
    timer = setTimeout(refresh, 120);
  });
})();
